import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, TemplateRef } from '@angular/core';
import { IonCheckbox } from '@ionic/angular/standalone';

@Component({
  selector: 'app-nbs-select-dropdown-option',
  templateUrl: './nbs-select-dropdown-option.component.html',
  styleUrls: ['./nbs-select-dropdown.component.css'],
  imports: [IonCheckbox, CommonModule],
  standalone: true,
})
export class NbsSelectDropdownOptionComponent {
  @Input() value!: string | number;
  @Input() hide?: boolean = false;
  @Output() selectEmitter = new EventEmitter<{ value: any; checked: boolean }>();
  @Input() indeterminate: boolean = false;
  @Input() checked: boolean = false;
  @Input() hideCheckBox: boolean = false;
  @Input() disabled?: boolean = false;
  @Input() multiSelect: boolean = false; // Add this input
  // @Input() showSpan?: boolean = true;
  @ViewChild('content') content!: ElementRef<HTMLSpanElement>;

  labelValue: string | null = null;

  constructor() {}

  onSelect(event: MouseEvent): void {
    event.stopPropagation(); // prevents closing the dropdown immediately after selecting an item
    this.selectEmitter.emit({ value: this.value, checked: !this.checked });
    // TODO Emit the current value and the *opposite* of the current checked state,
    // as clicking means we want to toggle it.
  }

  // getIsHideCheckBox() {
  //   return this.hideCheckBox !== true;
  // }

  getStyleClass() {
    return { option: true, hide: this.hide, 'selected-background': this.checked && !this.multiSelect };
    // 'selected-background': this.hideCheckBox };
  }
}
